import { atom, useRecoilState } from "recoil";
import { useWithImmer } from "../../../helpers/use-with-immer";
import * as _l from "./literal";
import * as _t from "./types";

export const signatureStyleStore = atom<Record<string, _t.SignatureStyles>>({
  key: "signatureStyle",
  default: _l.INITIAL_SIGNATURE_STYLES,
});

export default function useSignatureStyle() {
  const [signatureStyle, setStyle] = useWithImmer(
    useRecoilState(signatureStyleStore)
  );

  const setInitialSignatureStyle = (
    tenant: string,
    data: _t.SignatureStyles
  ) => {
    setStyle((draft) => {
      draft[tenant] = data;
    });
  };

  const updateStyle = <K extends keyof _t.SignatureStyles>(
    tenant: string,
    key: K,
    value: _t.SignatureStyles[K]
  ) => {
    setStyle((draft) => {
      if (draft[tenant]) {
        draft[tenant][key] = value;
      }
    });
  };

  const updateSubStyle = (
    tenant: string,
    field: _t.SignatureStyleFields,
    key: "font" | "size" | "weight" | "color",
    value: string | number
  ) => {
    setStyle((draft) => {
      if (draft[tenant] && draft[tenant][field]) {
        (draft[tenant][field][key] as string | number) = value;
      }
    });
  };

  const loadTenantStyle = (tenant: string): _t.SignatureStyles | undefined => {
    return signatureStyle[tenant];
  };

  return {
    signatureStyle,
    setStyle,
    updateStyle,
    updateSubStyle,
    setInitialSignatureStyle,
    loadTenantStyle,
  };
}
